import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'reactstrap';

const ReturnBtnComponent = () => {
  const lang_choiced = useSelector((state) => state.lang_change);

    return ( <Button
        color="danger"
        onClick={() =>
          window.location.replace(
            `/#/tickets`
          )
        }
      >
        {lang_choiced.pages.tickets.ticket.btnClose} &larr;
      </Button> );
}
 
export default ReturnBtnComponent;